import Splide from '@splidejs/splide';

(() => {
  if (!document.querySelector('.module-carousel-tabs')) return;

  // create tab titles
  document.querySelectorAll('.module-carousel-tabs').forEach((item) => {
    // add class to parent if parent has theme-dark class
    if (item.closest('.theme-dark')) {
      item.closest('.theme-dark').classList.add('module-dark-img');
    }

    let tabTitles = '';
    document.querySelectorAll('.carousel-tab').forEach((tab, i) => {
      const tabName = tab.querySelector('h3').textContent || `Category ${i}`;

      tabTitles += /* html */ `
        <div class="tab-title" tab-id="${i}" tabindex="0">
          <span class="tab-title-text">
            <img src="https://us.evocdn.io/dealer/1334/content/media/My_Theme/ob-icon-sale.svg" width="22" height="22" alt="" />
            ${tabName}
          </span>
        </div>`;

      // tab wrapper
      const tabContent = document.createElement('div');
      tabContent.className = 'js-tab splide';
      tabContent.setAttribute('tab-id', i);

      // carousel
      const slider = document.createElement('div');
      slider.className = 'js-carousel-slider carousel-slider splide__track';
      const sliderInner = document.createElement('div');
      sliderInner.className = 'splide__list';

      document.querySelectorAll('.carousel-tab').forEach((carousel, n) => {
        if (i === n) {
          sliderInner.insertAdjacentHTML('beforeend', '<div class="splide__slide ghost-slide"></div>');
          sliderInner.insertAdjacentHTML('beforeend', '<div class="splide__slide ghost-slide"></div>');
          carousel.querySelectorAll('.tile').forEach((tile) => {
            const splideSlide = document.createElement('div');
            splideSlide.className = 'splide__slide';
            splideSlide.append(tile);
            sliderInner.append(splideSlide);
          });
          sliderInner.insertAdjacentHTML('beforeend', '<div class="splide__slide ghost-slide"></div>');
          sliderInner.insertAdjacentHTML('beforeend', '<div class="splide__slide ghost-slide"></div>');
        }
      });
      slider.append(sliderInner);
      tabContent.append(slider);
      document.querySelector('.js-tabbed-content').append(tabContent);

      // tidy up original merch containers
      tab.closest('.col-sm-12').style.display = 'none';
    });
    item.querySelector('.js-tabs').innerHTML = tabTitles;

    item.querySelectorAll('.splide').forEach((splide) => {
      const merchSlider = new Splide(splide, {
        type: 'slide',
        perPage: 5,
        perMove: 1,
        gap: 20,
        pagination: false,
        arrows: true,
        start: 2,
        breakpoints: {
          1199: {
            perPage: 3,
          },
          768: {
            perPage: 1,
          },
        },
      });

      // Removes tabindex from all slides outside of view
      const updateTabindex = () => {
        const activeSlide = splide.querySelector('.splide__slide.is-active');
        const activeElements = activeSlide ? activeSlide.querySelectorAll('a, button') : [];
        let fourthSlideAfterActive = activeSlide;
        for (let i = 0; i < 4; i += 1) {
          fourthSlideAfterActive = fourthSlideAfterActive
            ? fourthSlideAfterActive.nextElementSibling : null;
        }

        const fourthSlideAfterActiveElements = fourthSlideAfterActive ? fourthSlideAfterActive.querySelectorAll('a, button') : [];

        activeElements.forEach((element) => {
          element.setAttribute('tabindex', -1);
        });

        fourthSlideAfterActiveElements.forEach((element) => {
          element.setAttribute('tabindex', -1);
        });

        let currentSlide = fourthSlideAfterActive;

        while (currentSlide) {
          const currentSlideElements = currentSlide.querySelectorAll('a, button');
          currentSlideElements.forEach((element) => {
            element.setAttribute('tabindex', -1);
          });
          currentSlide = currentSlide.nextElementSibling;
        }
      };

      merchSlider.on('mounted', () => {
        setTimeout(updateTabindex, 1000);
      });

      merchSlider.on('moved', () => {
        setTimeout(updateTabindex, 1000);
      });

      merchSlider.mount();
    });
  });
})();
